import React, { useState, useEffect } from 'react'

export const ReduxExperiment = () => {
	return (
		<>
		<div><h1>Redux</h1></div>
		</>
	)
}